export default __webpack_public_path__ + "static/media/AggregatedEnergyIcon.2b0a2804.svg";